// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__32lNO","col":"styles_col__BkMQy","fulfillmentStatus":"styles_fulfillmentStatus__3I6tq","emailCol":"styles_emailCol__KrxuO"};